export class PayablesDashboardReq{
    fromDate?:any
    toDate?:any
    unitId?:number
    supplierId?:number
    vendorId?:number
    buyerId?:number
    company?:any
    year?:number
    month?:number
    constructor(
        fromDate?:any,
        toDate?:any,
        unitId?:number,
        supplierId?:number,
        vendorId?:number,
        buyerId?:number,
        company?:any,
            year?:number,
    month?:number
    ){
     this.fromDate=fromDate
     this.toDate=toDate
     this.unitId=unitId
     this.supplierId=supplierId
        this.vendorId=vendorId 
        this.buyerId=buyerId 
        this.company=company
        this.year=year
        this.month=month
    }
}